import header from '@/components/Header/translations';
import paymentReminder from '@/views/PaymentReminder/translations';
import contractList from '@/views/ContractList/translations';
import orderManagement from '@/views/Order/translations';
import pagination from '@/components/Pagination/translations';
import calendar from '@/components/Calendar/translations';
import contractNew from '@/views/ContractNew/translations';
import contractDetail from '@/views/ContractDetail/translations';
import contractRedeem from '@/views/ContractRedeem/translations';
import contractRenew from '@/views/ContractRenew/translations';
import valueAdjustmentList from '@/views/ValueAdjustmentList/translations';
import cashLog from '@/views/CashLog/translations';
import searchResult from '@/views/SearchResult/translations';
import clientList from '@/views/ClientList/translations';
import clientDetail from '@/views/ClientDetail/translations';
import userPassword from '@/views/UserPassword/translations';

import contractEditor from '@/views/ContractEditor/translations';


import auth from './auth';
import search from './search';
import loan from './loan';
import call from './call';
import notification from './notification';
import client from './client';
import asset from './asset';

import en from './en.json';
import vi from './vi.json';

export default {
  en: {
    ...en,
    ...header.en,
    ...paymentReminder.en,
    ...contractList.en,
    ...orderManagement.en,
    ...auth.en,
    ...search.en,
    ...pagination.en,
    ...calendar.en,
    ...loan.en,
    ...call.en,
    ...notification.en,
    ...client.en,
    ...contractNew.en,
    ...contractDetail.en,
    ...contractRedeem.en,
    ...contractRenew.en,
    ...valueAdjustmentList.en,
    ...cashLog.en,
    ...searchResult.en,
    ...clientList.en,
    ...clientDetail.en,
    ...userPassword.en,
    ...contractEditor.en,
    ...asset.en
  },
  vi: {
    ...vi,
    ...header.vi,
    ...paymentReminder.vi,
    ...contractList.vi,
    ...orderManagement.vi,
    ...auth.vi,
    ...search.vi,
    ...pagination.vi,
    ...calendar.vi,
    ...loan.vi,
    ...call.vi,
    ...notification.vi,
    ...client.vi,
    ...contractNew.vi,
    ...contractDetail.vi,
    ...contractRedeem.vi,
    ...contractRenew.vi,
    ...valueAdjustmentList.vi,
    ...cashLog.vi,
    ...searchResult.vi,
    ...clientList.vi,
    ...clientDetail.vi,
    ...userPassword.vi,
    ...contractEditor.vi,
    ...asset.vi
  }
};
